import React, { useMemo } from 'react'
import { Honor, Certificate } from '@homepages/shared/constants/aboutUs'
import { colorTheme, colorWhite } from '@homepages/shared/styles/variables'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

import { Addresses } from '@homepages/shared/constants/aboutUs'

import Layout from '../components/LayoutNew'
import SEO from '../components/seo'

import './about.scss'
import HomeSection3 from '../containers/HomeSection3'
import genZHAge from '../utils/genZHAge'

const ContactPage = () => {
  const { aboutUsBanner, certificates } = useStaticQuery(graphql`
    query {
      aboutUsBanner: file(relativePath: { eq: "aboutUs/sanya.png" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      certificates: allFile(
        filter: { relativePath: { glob: "aboutUs/certificate/**/*_*" } }
        sort: { fields: name }
      ) {
        nodes {
          name
          childImageSharp {
            fluid(maxWidth: 348, maxHeight: 224, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  const certificateNodes = useMemo(() => {
    if (certificates) {
      return certificates.nodes
    }

    return []
  }, [certificates])

  return (
    <Layout
      className="contact-page"
      headerBackground={colorWhite}
      fontColor={colorTheme}
    >
      <SEO
        title="关于我们"
        description="成为本地生活客户的商业操作系统，这是我们成立的初衷"
      />

      <div className="about-us">
        <div className="head">
          <div className="head-info">
            <div className="head-info-title">关于我们</div>
            <div className="head-info-desc">成为本地生活客户的</div>
            <div className="head-info-desc">商业操作系统，这是</div>
            <div className="head-info-desc last">我们成立的初衷</div>
            <div className="head-info-sub">致力于让每个老板都能轻松开店</div>
          </div>
          <div className="head-img">
            <Img fluid={aboutUsBanner.childImageSharp.fluid} />
          </div>
        </div>

        <div className="desc">
          <div className="desc-title desktop-only">
            深耕行业多年，致力于推动数字化变革
          </div>
          <div className="desc-title mobile-only">
            <div className="">深耕行业多年，</div>
            <div>致力于推动数字化变革</div>
          </div>
          <div className="desc-content">
            {`精耕细作${genZHAge()}年，再惠专注于为中国本地生活服务领域的线下商户提供一站式的开店解决方案，帮助线下门店，特别是中国的数百万中腰部餐厅，运营小红书、抖音、b站等社交媒体和美团点评、淘宝闪购等交易平台，通过基于微信和企业微信的SCRM沉淀和运营商户的私域流量池。`}
          </div>
        </div>

        <div className="certificate">
          <h3>权威认证</h3>
          <div className="certificate-list">
            {Certificate.map(certificate => (
              <div className="item" key={certificate.desc}>
                <div className="banner">
                  <img src={certificate.img} alt={certificate.desc} />
                </div>
                <div className="info">{certificate.desc}</div>
              </div>
            ))}
            <div className="item">
              <div className="half-width">
                <div className="banner">
                  <img
                    src={require('@homepages/zaihui/src/images/aboutUs/certificate/专精特新.jpg')}
                  ></img>
                </div>

                <div className="info">专精特新证书</div>
              </div>
            </div>
          </div>
        </div>

        <div className="honor">
          <h3>公司荣誉</h3>
          <div className="honor-list">
            {Honor.map((item, index) => (
              <div className="item" key={index}>
                <img src={item.img} className="banner"></img>
                <div className="info">{item.desc}</div>
              </div>
            ))}
            <div className="item single">
              <img
                src={require('@homepages/zaihui/src/images/aboutUs/honor/2021923-144157.jpeg')}
                className="banner"
              ></img>
              <div className="info">长风营商环境贡献奖</div>
            </div>
            <div className="item double-width">
              <img
                src={require('@homepages/zaihui/src/images/aboutUs/honor/2021年度FBCF食品行业最佳数字营销服务商-奖状&奖杯.jpg')}
                className="banner"
              ></img>
              <div className="info">
                2021 年度 FBCF 食品行业最佳数字营销服务商
              </div>
            </div>
            <div className="item double-width">
              <img
                src={require('@homepages/zaihui/src/images/aboutUs/certificate/202182-17439.jpeg')}
                className="banner"
              ></img>
              <div className="info">赵洋-2020上海市青年创业英才</div>
            </div>
          </div>
        </div>

        <div className="history">
          <div className="history-title">乘风破浪，飞速成长</div>
          <div className="history-content">
            从复兴 SOHO
            到红坊，从红坊到凯利，后搬迁到宏汇、德必，再到如今的海亮大厦
            <br />
            再惠犹如一位茁壮成长的少年，从一座城到几十座城，从最初的几个人，到现在的一千多人
            <br />
            时间让人获得成长，回顾过去，那些困难与挑战让我们嘴角上扬
            <br />
            时间让人充满力量，展望未来，一群人一起走，走得更远
          </div>
        </div>
      </div>

      <HomeSection3 />
    </Layout>
  )
}

export default ContactPage
